import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-input-text',
  templateUrl: './custom-input-text.component.html',
  styleUrls: ['./custom-input-text.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputTextComponent),
      multi: true
    }
  ],
  imports: [CommonModule, InputTextModule, FormsModule, ReactiveFormsModule, TableModule]
})
export class CustomInputTextComponent implements ControlValueAccessor {

  onTouched: () => void = () => { };
  onChange: (value: string) => void = () => { };

  @Input() class: string = "";
  @Input() labelText: string = "";
  @Input() required: boolean = false;
  @Input() value: string = "";
  @Input() dataKey: string = "";
  @Input() disabled: boolean = false;
  @Input() inputClass: string = '';
  @Input() recovery: boolean = false;
  @Input() maxLength: number | null = null;
  @Output() onChangeText = new EventEmitter<string>();
  @Output() onChangeTextOnBlur = new EventEmitter<string>();

  get characterCount(): number {
    return this.value?.length || 0;
  }

  get isMaxLengthExceeded(): boolean {
    return this.maxLength !== null && this.characterCount > this.maxLength;
  }

  changeText(event: any) {
    this.value = event.target.value;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeText.emit(this.value);
  }

  changeTextOnBlur(event: any) {
    this.value = (event.target.value || '').trim();
    this.onChange(this.value);
    this.onTouched();
    this.onChangeTextOnBlur.emit(this.value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectAllText(event: Event) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

}
